import gql from 'graphql-tag';

const FAQ_ENTRIES_QUERY = gql`
    query FaqEntries {
        faqEntries (sort: "question:asc") {
            id
            question
            answer
            blog_category {
                id
                title
            }
            tags {
                name
                id
            }
        }
    }
`;

export default FAQ_ENTRIES_QUERY;
